// extracted by mini-css-extract-plugin
var _1 = "MessageDeleteDialog_body__p066G";
var _2 = "MessageDeleteDialog_footer__MnyCb";
var _3 = "MessageDeleteDialog_header__WJRdO";
export { _1 as "body", _2 as "footer", _3 as "header" }
